import angular from 'angular';

import { PROVINCES, CONSTANTS } from 'config';

import { forEach, each, concat, map, reduce,
  isEqual, clone, filter, remove, isString } from 'lodash';

import template from './tsz-report.html';
import './tsz-report.styl';

function controller($filter, $scope, $rootScope, $state, $stateParams,
  $tszToast, $mdDialog, $mdMedia, $base64, AuthService,
  CatalogService, ReportService, CompanyService) {

  'ngInject';

  const PROJECT = 'PROJECT';

  const PROJECT_KEYS = ['name', 'province', 'address', 'postal_code', 'code', 'evaluator', 'design_type', 'building_usage', 'area'];

  this.PROJECT_ID = PROJECT;

  this.parameters = ['AS', 'T', 'CO', 'CA', 'NPA', 'RFE', 'P', 'EO', 'IPCI', 'IB'];

  this.meredicteVersion = $stateParams.v ? CONSTANTS.VERSION[$stateParams.v] : CONSTANTS.VERSION.V2;

  this.BUILDING_USAGE = CONSTANTS.BUILDING_USAGE;
  this.PROJECT_TYPE = CONSTANTS.PROJECT_TYPE;

  this.emptyCounter = {};
  this.totals = {};

  this.refreshTotal = () => {
    this.total = this.meredicteVersion.nParams + PROJECT_KEYS.length;
    console.log(this.total);
  };

  this.report = {};
  this.savedReport = {};

  this.changed = false;

  this.loading = false;

  this.generatingReport = false;
  this.downloadingReport = false;

  this.completion = 0;

  this.completed = false; // all params

  this.provinces = PROVINCES;

  this.companyId = AuthService.getCompanyId();

  this.canGenerateReports = AuthService.canGenerateReports();
  this.canEditParameters = AuthService.canEditParameters();
  this.canSeeCuantitativeResults = AuthService.canSeeCuantitativeResults();
  this.canCompareProjects = AuthService.canCompareProjects();

  this.bigScreen = $mdMedia('gt-md');

  const BAR_COLORS = ['#C55A11', '#2E75B5', '#7CB653'];

  this.chartOptions = {
    tooltips: { enabled: this.canSeeCuantitativeResults },
    legend: { display: false },
  };

  this.mainChart = {
    labels: ['PP', 'NPG', 'NRG'],
    datasetOverride: { backgroundColor: BAR_COLORS, borderColor: BAR_COLORS },
  };

  //
  // REPORT ACTIONS
  //

  this.isSaveBtnEnabled = () => this.changed && !this.report.downloadable;

  this.showGenerateReportBtn = () => this.completed && !this.report.downloadable;

  this.showGenerateReportBox = () =>
    this.canGenerateReports && !this.report.downloadable && (this.completed || this.price > 0);

  this.refresh = () => {
    this.refreshTotal();
    this.refreshAllCounters();
    this.refreshPricing();
    this.checkChanges();
  };

  this.isBase64 = (str) => {
    const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    return base64regex.test(str);
  };

  // compatibility: json or base64
  this.importReport = ($fileContent) => {
    const reportId = this.report.id;

    let report = $fileContent;

    if (isString($fileContent)) {
      const content = this.isBase64($fileContent) ? $base64.decode($fileContent) : $fileContent;
      report = JSON.parse(content);
    }

    // if the imported file doesn't contain the version, assume V1
    if (!report.meredicteVersion) {
      report.meredicteVersion = CONSTANTS.VERSION.V1.name;
    }

    if (report.meredicteVersion !== $stateParams.v) {
      $state.transitionTo('report', { v: report.meredicteVersion }, { notify: false });
    }

    this.meredicteVersion = CONSTANTS.VERSION[report.meredicteVersion];
    this.loadReportSchema();

    report.id = reportId;
    this.report = report;
    this.savedReport = clone(report);
    this.report.generated = false;
    this.report.downloadable = false;
    this.refresh();
    this.calculate(this.report);

    this.changed = true; // to enable save without updating any field
  };

  const importEventListener = $scope.$on('import_report', (event, report) => {
    this.importReport(report);
    $tszToast.showSuccess(`Proyecto "${report.name}" importado correctamente`);
  });

  $scope.$on('$destroy', () => {
    importEventListener();
  });

  this.delete = (ev) => {
    ReportService.deleteAction(this.report, ev, () => {
      $state.go('home');
    });
  };

  this.export = () => {
    ReportService.export(this.report);
  };

  //
  // Report rendering
  //

  this.showCategory = (category) =>
    (category.subcategories && category.subcategories.length > 1) ||
    (category.parameters && category.parameters.length > 1);

  this.calculate = (report) => {
    ReportService.calculate(report)
    .then((response) => {
      this.reportOutput = response;
      this.refreshMainChart();
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al calcular el informe');
    });
  };

  this.refreshMainChart = () => {
    if (this.selectedReport) {
      this.mainChart.data = [
        [$filter('number')(this.reportOutput.pp, 2), $filter('number')(this.reportOutput.npg, 2), $filter('number')(this.reportOutput.nrg, 2)],
        [$filter('number')(this.selectedReport.pp, 2), $filter('number')(this.selectedReport.npg, 2), $filter('number')(this.selectedReport.nrg, 2)],
      ];
      this.mainChart.series = [$filter('limitTo')(this.report.name, 30), $filter('limitTo')(this.selectedReport.name, 30)];
      this.chartOptions.legend.display = true;
    } else {
      this.mainChart.data = [$filter('number')(this.reportOutput.pp, 2), $filter('number')(this.reportOutput.npg, 2), $filter('number')(this.reportOutput.nrg, 2)];
      this.mainChart.series = null;
      this.chartOptions.legend.display = false;
    }

    this.mainChart.datasetOverride.backgroundColor[2] = $filter('nrgColor')(this.reportOutput.nrg);
    this.nrgStyle = { color: $filter('nrgColor')(this.reportOutput.nrg) };
  };

  this.download = () => {
    ReportService.download(this.report);
  };

  this.generateFreeReport = () => {
    ReportService.generate(this.reportId)
    .then(() => {
      $tszToast.showSuccess('Informe generado correctamente');
      this.report.generated = true;
      this.report.downloadable = true;
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al generar el informe');
    }).finally(() => {
      this.generatingReport = false;
    });
  };

  this.generateAndRedirectToTPV = () => {
    CompanyService.getPaymentDetails(this.companyId, this.reportId)
    .then((data) => {
      document.getElementById('Ds_SignatureVersion').value = data.dsSignatureVersion;
      document.getElementById('Ds_MerchantParameters').value = data.dsMerchantParameters;
      document.getElementById('Ds_Signature').value = data.dsSignature;
      const redsysForm = document.getElementById('redsysForm');
      redsysForm.action = data.redsysUrl;
      redsysForm.submit();
    }).catch(() => {
      $tszToast.showError('Se ha producido un error durante la generación del informe');
    }).finally(() => {
      this.generatingReport = false;
    });
  };

  this.generate = () => {
    this.generatingReport = true;
    if (AuthService.isAdmin()) {
      this.generateFreeReport();
    } else if (this.price > 0) {
      this.generateAndRedirectToTPV();
    } else {
      this.generateFreeReport();
    }
  };

  this.save = () => {
    this.loading = true;

    if (this.reportId) {
      // UPDATE REPORT
      ReportService.update(this.report)
      .then((response) => {
        this.report = response.toJSON();
        this.savedReport = clone(this.report);
        $tszToast.showSuccess('Informe guardado');
      }).catch((err) => {
        if (err.data && err.data.code) {
          $tszToast.showErrorI18n(err.data.code, 'Se ha producido un error al actualizar el informe');
        } else {
          $tszToast.showError('Se ha producido un error al actualizar el informe');
        }
      }).finally(() => {
        this.loading = false;
        this.checkChanges();
      });
    } else {
      // CREATE REPORT
      ReportService.create(this.report)
      .then((response) => {
        this.report = response.toJSON();
        this.savedReport = clone(this.report);
        const extras = {
          toast: {
            message: 'Informe guardado satisfactoriamente.',
            opts: { success: true },
          },
        };
        $state.go('report', { id: this.report.id, extras });
      }).catch((err) => {
        if (err.data && err.data.code) {
          $tszToast.showErrorI18n(err.data.code, 'Se ha producido un error al crear el informe');
        } else {
          $tszToast.showError('Se ha producido un error al crear el informe');
        }
      }).finally(() => {
        this.loading = false;
        this.checkChanges();
      });
    }
  };

  this.refreshPricing = () => {
    if (this.report.building_usage && this.report.design_type && this.report.area) {
      ReportService.getPrice(this.companyId, this.report)
      .then((response) => {
        this.price = Math.round(response.price);
      }).catch((err) => {
        this.error = err.message;
      });
    } else {
      this.price = '---';
    }
  };

  this.refreshAllCounters = () => {
    this.refreshProjectCounters();
    forEach(this.reportSchema, (p) => {
      this.refreshCounters(p);
    });
  };

  this.refreshProgress = () => {
    this.completion = reduce(this.emptyCounter, (p, c) => p - c, this.total);
    this.completed = this.completion === this.total;
  };

  this.refreshProjectCounters = () => {
    this.refreshCounters(PROJECT);
  };

  this.checkChanges = () => {
    this.changed = !isEqual(this.report, this.savedReport);
  };

  this.onParamChange = (p) => {
    this.checkChanges();
    this.refreshCounters(p);
    this.refreshProgress();
    this.calculate(this.report);
  };

  this.refreshCounters = (p) => {

    let keys = [];

    if (p === PROJECT) {
      keys = PROJECT_KEYS;
    } else {
      if (p.parameters) {
        keys = concat(keys, map(filter(p.parameters, (o) => (o.type !== 'title')), 'name'));
      }
      forEach(p.categories, (category) => {
        keys = concat(keys, map(category.parameters, 'name'));
        forEach(category.subcategories, (subcategory) => {
          keys = concat(keys, map(subcategory.parameters, 'name'));
        });
      });
    }

    const total = keys.length;
    let empty = 0;

    each(keys, (key) => {
      if ((this.report[key] !== 0) && !this.report[key]) {
        empty += 1;
      }
    });

    if (p.name) {
      this.emptyCounter[p.name] = empty;
      this.totals[p.name] = total;
    } else {
      this.emptyCounter[p] = empty;
      this.totals[p] = total;
    }

    this.refreshProgress();
  };

  this.loadCalculatedReports = (id) => {
    ReportService.get_calculated_reports(id)
    .then((result) => {
      this.reports =
        remove(result, (o) => (o.id != this.reportId)); // eslint-disable-line
      if (this.reports) {
        this.showCompareSelect = true;
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  this.compareProject = () => {
    this.selectedReport = JSON.parse(this.selectedReportRaw);
    if (this.selectedReport) {
      this.comparisonMode = true;
    } else {
      this.comparisonMode = false;
    }

    console.log(`comparisonMode: ${this.comparisonMode}`);

    this.refreshMainChart();
  };

  this.loadReport = (reportId) => {

    this.loading = true;
    ReportService.get(reportId)
    .then((response) => {
      this.report = response.toJSON();
      this.meredicteVersion = CONSTANTS.VERSION[this.report.meredicteVersion];
      this.savedReport = clone(this.report);

      this.loadReportSchema();
      this.calculate(this.report);
      this.refresh();
    }).catch((err) => {
      this.error = err.message;
    }).finally(() => {
      this.loading = false;
    });
  };

  this.loadReportSchema = () => {
    CatalogService.getReportSchema(this.meredicteVersion.name)
      .then((response) => {
        this.reportSchema = response.data;
        this.refresh();
      }).catch((err) => {
        console.error(`Error getting report schema: ${err}`);
      }).finally(() => {
        // something
      });
  };

  this.showOptionInfoDialog = (param) => {

    $mdDialog.show({
      controller: () => {
        $scope.close = () => {
          $mdDialog.hide();
        };
      },
      controllerAs: 'ctrl',
      templateUrl: `/static/modals/${param}.html`,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

  this.loadReportSchema();

  if (this.canCompareProjects) {
    this.loadCalculatedReports(this.companyId);
  }

  if (this.reportId) {
    // update
    this.loadReport(this.reportId);
  } else {
    // create
    this.report = {
      meredicteVersion: this.meredicteVersion.name,
    };
    this.calculate(this.report);
  }

  if ($state.params.extras) {
    const params = $state.params.extras;
    if (params.toast) {
      const toast = params.toast;
      $tszToast.show(toast.message, toast.opts);
    }
  }

  $rootScope.$on('clickReportParamInfo', (event, parameter) => {
    console.log(`clickReportParamInfo event received: ${parameter}`);
    this.showOptionInfoDialog(parameter);
  });

}

export default {
  template,
  bindings: {
    companyId: '<',
    reportId: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-report/tsz-report.js